var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10989 6.00008H4.88989C5.99656 6.00008 6.44656 5.21675 5.89656 4.26008L5.64989 3.83341C5.58989 3.73008 5.47989 3.66675 5.35989 3.66675L2.63989 3.66675C2.51989 3.66675 2.40989 3.73008 2.34989 3.83341L2.10323 4.26008C1.55323 5.21675 2.00323 6.00008 3.10989 6.00008Z",
    fill: "#FF6674"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.93002 3.33343H5.07335C5.20335 3.33343 5.28335 3.19343 5.21669 3.08343L5.00335 2.71677C4.45335 1.7601 3.54669 1.7601 2.99669 2.71677L2.78335 3.08343C2.72002 3.19343 2.80002 3.33343 2.93002 3.33343Z",
    fill: "#FF6674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpOrange);
export default __webpack_public_path__ + "static/media/arrow-up-orange.55b0e5d6faae189d6eaec171784d6729.svg";
export { ForwardRef as ReactComponent };